import React, { useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEnvironment } from '../contexts/EnvironmentContext';
import { useApp } from '../contexts/AppContext';
import Header from './Header';

const ConsoleLayout = ({ children }) => {
  const location = useLocation();
  const { environments } = useEnvironment();
  const { selectedAppName: appNameFromContext } = useApp();

  // Extract selectedApp (service_id) from pathname since ConsoleLayout is outside Routes
  const selectedApp = useMemo(() => {
    const match = location.pathname.match(/^\/app\/([^\/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }, [location.pathname]);

  // Resolve service_id to service_name for AppContext
  const selectedAppName = useMemo(() => {
    if (!selectedApp) return null;
    if (appNameFromContext) return appNameFromContext;
    for (const env of environments) {
      const app = env.apps?.find(a => a.id === selectedApp);
      if (app) return app.name;
    }
    return selectedApp;
  }, [selectedApp, appNameFromContext, environments]);

  return (
    <div className="flex flex-col h-screen bg-background-primary">
      {/* HEADER - Full width at top */}
      <Header />

      {/* MAIN CONTENT AREA - Full width */}
      <div className="flex-1 overflow-auto bg-background-primary p-6">
        {children}
      </div>
    </div>
  );
};

export default ConsoleLayout;
